import styled from 'styled-components';
import { ParagraphMediumText } from '../Texts';

const Line = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.border.dashed};
  width: 100%;
`;

const Container = styled.div`
  padding-top: 15px;
  padding-bottom: 8px;
  color: ${({ theme }) => theme.text.regular};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LineAndLabel = ({ text }) => {
  return (
    <Container>
      <Line style={{ width: '30%', marginRight: 8 }} />
      <ParagraphMediumText style={{ textWrapMode: 'nowrap', fontWeight: 500 }}>
        {text}
      </ParagraphMediumText>
      <Line style={{ marginLeft: 8 }} />
    </Container>
  );
};

export default LineAndLabel;
